module.exports = __webpack_public_path__ + "media/landing_page/apple-icon-kale-48f1466c.svg";